module.exports = __webpack_public_path__ + "media/images/athletes/1447-9b1efcf900a6ab08d7f0aab7fc4784dd.png";